import { FC } from 'react';
import { faHandHoldingHeart, faMap, faMapLocationDot, faPlane } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { i18nTB } from 'utils/shared/utils';

const WHY_FLYEAST_FEATURES: { icon: any; textKey: string }[] = [
  { icon: faMapLocationDot, textKey: 'trip_builder.why_flyeast_feature_1' },
  { icon: faPlane, textKey: 'trip_builder.why_flyeast_feature_2' },
  { icon: faMap, textKey: 'trip_builder.why_flyeast_feature_3' },
  { icon: faHandHoldingHeart, textKey: 'trip_builder.why_flyeast_feature_4' },
];

const TripBuilderClientWhyFlyeast2: FC = () => {
  const { t, i18n } = useTranslation(undefined, { i18n: i18nTB });
  const isRtl = i18n.language === 'he';

  return (
    <section className="tb2-why-flyeast" dir={isRtl ? 'rtl' : 'ltr'}>
      <div className="tb2-why-flyeast-line" aria-hidden="true" />
      <h2 className="tb2-why-flyeast-title">{t('trip_builder.why_flyeast_title')}</h2>
      <div className="tb2-why-flyeast-cards">
        {WHY_FLYEAST_FEATURES.map(({ icon, textKey }) => (
          <article className="tb2-why-flyeast-card" key={textKey}>
            <FontAwesomeIcon icon={icon} aria-hidden="true" />
            <p>{t(textKey)}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default TripBuilderClientWhyFlyeast2;
